import React, { ChangeEvent, FC, FocusEvent } from 'react';
import { Grid, ListItem, Typography, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import { LeaderboardConfig, LeaderboardEventScores } from 'api';

interface Props {
  index: number;
  item: LeaderboardEventScores;
  bucket: string;
}

const useStyles = makeStyles(theme => ({
  input: {
    width: theme.spacing(8),
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      textAlign: 'center',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));

const ScoringItem: FC<Props> = ({ bucket, item, index }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { setFieldValue } = useFormikContext<LeaderboardConfig>();

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;

    setFieldValue(`${bucket}[${index}].score`, value);
  }

  function onBlur(event: FocusEvent<HTMLInputElement>) {
    const { value } = event.target;

    if (value === '') {
      setFieldValue(`${bucket}[${index}].score`, 0);
    }
  }

  return (
    <ListItem disableGutters>
      <Grid container justify="space-between">
        <Grid item xs={10} container alignItems="center">
          <Typography variant="body2">{t(`leaderboard:admin_${item.event}`)}</Typography>
        </Grid>

        <Grid item xs={2} container justify="flex-end">
          <TextField
            type="number"
            value={Number(item.score).toString()}
            className={classes.input}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default ScoringItem;
